// Product card behavior: wishlist toggle, variant swatches and quick add.
// Lives in assets (not the snippet's {% javascript %} tag) because Shopify does not
// bundle snippet JavaScript into compiled_assets/scripts.js.
(function () {
  var STORAGE_KEY = 'dlunchi:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  }

  function syncButton(button) {
    var handle = button.getAttribute('data-product-handle');
    var active = getWishlist().indexOf(handle) !== -1;
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;

    var handle = button.getAttribute('data-product-handle');
    var handles = getWishlist();
    var index = handles.indexOf(handle);

    if (index === -1) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }

    setWishlist(handles);
    document.querySelectorAll('[data-wishlist-toggle][data-product-handle="' + handle + '"]').forEach(syncButton);
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: handles } }));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllButtons);
  } else {
    syncAllButtons();
  }
})();

(function () {
  function setText(el, value) {
    if (el) el.textContent = value;
  }

  // `t` HTML-escapes interpolated values (D'Luchi → D&#39;Luchi); decode before textContent.
  function decodeEntities(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function getVariants(card) {
    if (!card._cardVariants) {
      var data = card.querySelector('[data-card-variants]');
      try {
        card._cardVariants = data ? JSON.parse(data.textContent) : [];
      } catch (e) {
        card._cardVariants = [];
      }
    }
    return card._cardVariants;
  }

  // Variant matching the clicked value plus the active value of every other group.
  // Falls back to an available variant with the clicked value (re-syncing the other
  // groups) when that exact combination doesn't exist or is sold out.
  function resolveVariant(card, swatch) {
    var index = Number(swatch.getAttribute('data-option-index'));
    var value = swatch.getAttribute('data-option-value');
    var selected = {};
    card.querySelectorAll('[data-card-swatch].product-card__swatch--active').forEach(function (active) {
      selected[active.getAttribute('data-option-index')] = active.getAttribute('data-option-value');
    });
    selected[index] = value;

    var withValue = getVariants(card).filter(function (variant) {
      return variant.options[index] === value;
    });
    var exact = withValue.find(function (variant) {
      return Object.keys(selected).every(function (key) {
        return variant.options[key] === selected[key];
      });
    });
    if (exact && exact.available) return exact;
    return (
      withValue.find(function (variant) {
        return variant.available;
      }) ||
      exact ||
      withValue[0]
    );
  }

  function selectSwatch(swatch) {
    var card = swatch.closest('[data-product-card]');
    if (!card) return;

    var variant = resolveVariant(card, swatch);
    if (!variant) return;
    var variantId = variant.id;
    var available = variant.available;

    card.querySelectorAll('[data-card-swatch]').forEach(function (other) {
      var index = other.getAttribute('data-option-index');
      var active = variant.options[index] === other.getAttribute('data-option-value');
      other.classList.toggle('product-card__swatch--active', active);
      other.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    setText(card.querySelector('[data-card-price]'), variant.price || '');

    var compareEl = card.querySelector('[data-card-compare]');
    if (compareEl) {
      if (variant.compare) {
        compareEl.textContent = variant.compare;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var badgeEl = card.querySelector('[data-card-discount-badge]');
    if (badgeEl) {
      if (variant.badge) {
        badgeEl.textContent = decodeEntities(variant.badge);
        badgeEl.hidden = false;
      } else {
        badgeEl.hidden = true;
      }
    }

    setText(card.querySelector('[data-card-note]'), decodeEntities(variant.note || ''));

    var cta = card.querySelector('[data-card-cta]');
    if (cta) {
      cta.setAttribute('data-variant-id', variantId);
      cta.disabled = !available;
      if (available) {
        cta.removeAttribute('aria-disabled');
      } else {
        cta.setAttribute('aria-disabled', 'true');
      }
      setText(
        cta.querySelector('[data-card-cta-label]'),
        available ? cta.getAttribute('data-label-add') : cta.getAttribute('data-label-sold-out')
      );
    }

    var baseUrl = card.getAttribute('data-product-url');
    if (baseUrl) {
      card.querySelectorAll('[data-card-link]').forEach(function (link) {
        link.setAttribute('href', baseUrl + '?variant=' + variantId);
      });
    }
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    event.preventDefault();
    selectSwatch(swatch);
  });
})();

// Quick add → Rebuy Smart Cart. Only active when the theme cart drawer isn't
// rendered (it owns `[data-add-to-cart]` and already defers to Rebuy).
(function () {
  var busy = false;

  function rebuyReady() {
    return window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function';
  }

  function openRebuy() {
    var cartApi = window.Rebuy.Cart;
    var pending = cartApi && typeof cartApi.fetchCart === 'function' ? cartApi.fetchCart() : null;
    return Promise.resolve(pending)
      .catch(function () {})
      .then(function () {
        window.Rebuy.SmartCart.show();
      });
  }

  function syncHeaderCount() {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count <= 0;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    if (document.querySelector('cart-drawer')) return;

    var button = event.target.closest('[data-add-to-cart]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || busy) return;

    busy = true;
    button.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        syncHeaderCount();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (rebuyReady()) return openRebuy();
        window.location.href = '/cart';
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        button.classList.remove('loading');
      });
  });
})();
